export const statusColor = [
  {
    value: null,
    name: "All",
    color: "default",
  },
  { value: "pending_review", name: "Pending Review", color: "review-design" },
  {
    value: "ReviewDesign",
    name: "Review Design",
    color: "review-design",
  },
  {
    value: "Designed",
    name: "Designed",
    color: "designed",
  },
  {
    value: "InProduction",
    name: "In Production",
    color: "in-production",
  },
  {
    value: "Fulfilled",
    name: "Fulfilled",
    color: "fulfilled",
  },
  {
    value: "Cancelled",
    name: "Cancelled",
    color: "cancelled",
  },
  {
    value: "Refunded",
    name: "Refunded",
    color: "refunded",
  },
  {
    value: "Error",
    name: "Error",
    color: "error",
  },
  {
    value: "OnHold",
    name: "On Hold",
    color: "onHold",
  },
  {
    value: "DesignRejected",
    name: "Design Rejected",
    color: "designRejected",
  },
];
